define.alias("shared/components/shared/wizards/device-setup", "preview-grid/components/shared/wizards/device-setup");